import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=192d6e92&scoped=true"
import script from "./Overview.vue?vue&type=script&setup=true&lang=js"
export * from "./Overview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192d6e92",
  null
  
)

export default component.exports